module.exports = __webpack_public_path__ + "img/offline_kiosk_02.8cda5372.png";